
<template>
  <div>
    <DialogTableExists :saving="loading.saving" :loading="loading.truck" model="o veículo">
      <template slot="header">
        Veículo com essa placa já cadastrado!
      </template>
      <template slot="content">
        <span class="subtitle-1 text-center">
          O veículo <span class="font-weight-bold">{{ truck.manufacturer }} - {{truck.color}}</span> com essa placa já está cadastrado no sistema!
        </span>
        <span class="subtitle-1 text-center mb-6">
          Você pode incluir outros modúlos na edição dos dados do veículo.
        </span>
      </template>
      <template slot="info">
        <v-col cols="6" class="py-1 ma-0" v-if="truck.model">Modelo: <span class="font-weight-medium">{{ truck.model }}</span></v-col>
        <v-col cols="6" class="py-1 ma-0" v-if="truck.manufacturer">Fabricante: <span class="font-weight-medium">{{ truck.manufacturer }}</span></v-col>
        <v-col cols="6" class="py-1 ma-0" v-if="truck.color">Cor: <span class="font-weight-medium">{{ truck.color }}</span></v-col>
        <v-col cols="6" class="py-1 ma-0" v-if="truck.plate">1º Placa: <span class="font-weight-medium">{{ truck.plate }}</span></v-col>
        <v-col cols="6" class="py-1 ma-0" v-if="truck.chassi">1º Chassi: <span class="font-weight-medium">{{ truck.chassi }}</span></v-col>
        <v-col cols="6" class="py-1 ma-0" v-if="truck.cargo_plate_1">2º Placa: <span class="font-weight-medium">{{ truck.cargo_plate_1 }}</span></v-col>
        <v-col cols="6" class="py-1 ma-0" v-if="truck.cargo_chassi_1">2º Chassi: <span class="font-weight-medium">{{ truck.cargo_chassi_1 }}</span></v-col>
        <v-col cols="6" class="py-1 ma-0" v-if="truck.cargo_plate_2">3º Placa: <span class="font-weight-medium">{{ truck.cargo_plate_2 }}</span></v-col>
        <v-col cols="6" class="py-1 ma-0" v-if="truck.cargo_chassi_2">3º Chassi: <span class="font-weight-medium">{{ truck.cargo_chassi_2 }}</span></v-col>
        <v-col cols="12" class="py-1 ma-0">
          <div class=" d-flex align-baseline ">
            <v-icon small >mdi-window-shutter-settings</v-icon> 
            <span class="ml-1 subtitle-2 font-weight-black">Cadastrado em:</span>
          </div>
          <v-list>
            <v-list-item v-for="depot in truck.all_depots" :key="depot[0]">
              <v-list-item-icon><v-icon>mdi-circle-small</v-icon></v-list-item-icon>
              <v-list-item-title>{{depot[1]}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
      </template>
      <template slot="actions">
        <v-spacer></v-spacer>
        <f-btn close @click="goBack"></f-btn>
        <f-btn save @click="openClientNewTab"  alt_text="Acessar dados do veículo" alt_icon="mdi-open-in-new"></f-btn>
      </template>
    </DialogTableExists>
  </div>
</template>

<script>
import Api from '@/api/index';
export default {
  name: 'TruckExist',
  components: {
    DialogTableExists: () => import("@/_backoffice/_registrations/components/shared/DialogTableExists.vue"),
  },
  data() {
    return {
      truck: {},
      loading:{
        truck:false,
      }
    }
  },
  methods: {
    getData() {
      this.getTruck()
    },
    getTruck() {
      this.loading.truck = true
      let id = this.$route.params.id
      Api.Truck.show(id).then(req => req.data).then(data => {
        this.truck = {...data}
      }).finally(()=>{
        this.loading.truck = false
      })
    },
    openClientNewTab(){
      const routeData = this.$router.resolve({name: 'ShowTruck', params: {id: this.truck.id}});
      window.open(routeData.href, '_blank');
    },
    goBack(){
      this.$router.push({name:'CreateTruck'})
    },

  },
  mounted() {
    this.getData()
  },
}
</script>